<template>
  <div id="overlay-fireworks-sales" :class="`overlay-fireworks-${level}`" :style="{ display: show ? 'block' : 'none' }">
    <div id="fireworks-animation"></div>

    <div :class="`overlay-content ${level}`">
      <h2 :class="`fireworks-title ${level}`">
        {{ title }} 🎉
      </h2>

      <div class="consultant-images">
        <div v-for="(img, index) in images" :key="index" class="consultant-image">
          <img class="rounded-circle m-2" :src="img" alt="Consultant Image" />
        </div>
      </div>

      <div class="consultant-names">
        <p :class="`h3 font-weight-bold mb-0 ${level}`">
          Felicidades
          <span v-for="(name, index) in consultants" :key="index">
            "{{ name.trim() }}"
            <template v-if="index === consultants.length - 2"> y </template>
            <template v-if="index < consultants.length - 2">, </template>
          </span>
          <br />
          Has guiado a {{ student }} hacia su próxima gran aventura.
        </p>
      </div>

      <div v-if="description" :class="`description-box ${level}`">
        <p :class="`description-message ${level}`" v-html="description"></p>
      </div>

      <div class="close-fireworks">
        <a href="#" :id="`fireworks-close-${level}`" @click.prevent="closeOverlay(level)">
          <i class="far fa-times-circle"></i>
        </a>
      </div>
    </div>
  </div>
</template>
<script>

import { eventBus, fireworksOptions, hideOverlay } from "../../utils/helpers";
import { loadAnimation } from "../../utils/confetti";
import Fireworks from 'fireworks-js';

export default {
  name: "OverlayFireworksSales",
  data() {
    return {
      show: false,
      title: '',
      description: '',
      level: '',
      badge: '',
      student: '',
      images: [],
      consultants: [],
      fireworks: null,
      confetti: null
    };
  },
  mounted() {
    eventBus.$on('show-fireworks', (level, student, consultants, images, message) => {
      this.show = true;
      this.level = level;
      this.student = student;
      this.images = images;
      this.consultants = consultants;

      this.getTitleDescription(level, message);
      this.startFireworks(level);
    });
  },
  methods: {
    startFireworks(level) {
      const parent = document.getElementById('overlay-fireworks-sales');
      const fireworksContainer = document.getElementById('fireworks-animation');

      let confettiContainer = document.getElementById('confetti-animation');

      if (!confettiContainer) {
        confettiContainer = Object.assign(document.createElement('div'), { id: 'confetti-animation' });
        parent.appendChild(confettiContainer);
      }

      this.stopFireworks();

      if (['budget', 'normal'].includes(this.level) && fireworksContainer) {
        this.fireworks = new Fireworks(fireworksContainer, fireworksOptions);
        this.fireworks.start();
      }

      if (['platinum', 'gold', 'silver'].includes(this.level)) {
        this.badge = `/images/${level}-badge-fireworks-sales.png`;
        this.confetti = loadAnimation('confetti-animation');
      }
    },
    stopFireworks() {
      if (this.fireworks) {
        this.fireworks.stop();
        const canvas = document.querySelector('#fireworks-animation canvas');
        if (canvas) {
          canvas.remove();  // Clean up the canvas element
        }
        this.fireworks = null;
      }
    },
    closeOverlay(level) {
      this.show = false;
      this.title = '';
      this.description = '';
      this.level = '';
      this.badge = '';
      this.student = '';
      this.images = [];
      this.consultants = [];

      this.stopFireworks();

      if (this.confetti) {
        this.confetti.stop();
        this.confetti = null;
      }

      localStorage.setItem('fireworks-close', 'true');
      hideOverlay(`overlay-fireworks-${level}`);
    },
    getTitleDescription(level, message) {
      switch (level) {
        case 'platinum':
          this.title = 'Venta Platinum';
          this.description = message;
          break;
        case 'gold':
          this.title = 'Venta Gold';
          this.description = message;
          break;
        case 'silver':
          this.title = 'Venta Silver';
          this.description = message;
          break;
        case 'budget':
          this.title = 'Venta Budget';
          this.description = message;
          break;
        default:
          this.title = 'Felicidades!';
          this.description = message;
      }
    }
  },
  beforeDestroy() {
    eventBus.$off('show-fireworks');

    this.stopFireworks();

    if (this.confetti) {
      this.confetti.stop();
    }
  }
}
</script>
